define(['./InputCtrlDirective'],
    (InputCtrlDirective)=> {
        return function () {
            const inputCtrlDirective = new InputCtrlDirective();
            const origLink = inputCtrlDirective.link;
            inputCtrlDirective.link = function (scope) {
                origLink.apply(this, arguments);
                scope.inline = true;
            };

            return inputCtrlDirective;
        };
    }
);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/basicinputs/InlineInputCtrlDirective.js
 **/